export default "__VITE_ASSET__DCvjjhMO__"